import { Input } from "src/design-system/Input";
import { UrlValueType } from "src/utils/url";

type CaseUrlPropertyInputProps = {
  value: UrlValueType | null;
  onChange: (value: UrlValueType | null) => void;
  onBlur: () => void;
  errored: boolean;
  errorMessage?: string;
};

export const CaseUrlPropertyInput: React.FC<CaseUrlPropertyInputProps> = ({
  value,
  onChange,
  onBlur,
  errored,
  errorMessage,
}) => {
  const urlValue = value?.url ?? "";
  const nameValue = value?.name ?? "";

  const handleUrlChange = (nextUrl: string) => {
    if (nextUrl === "" && nameValue === "") {
      onChange(null);
      return;
    }
    onChange({
      url: nextUrl,
      ...(nameValue === "" ? {} : { name: nameValue }),
    });
  };

  const handleNameChange = (nextName: string) => {
    if (urlValue === "" && nextName === "") {
      onChange(null);
      return;
    }
    onChange({
      url: urlValue,
      ...(nextName === "" ? {} : { name: nextName }),
    });
  };

  return (
    <div className="flex flex-col gap-2">
      <Input
        error={errored}
        errorMessage={errorMessage}
        placeholder="https://example.com"
        value={urlValue}
        onBlur={onBlur}
        onChange={(e) => handleUrlChange(e.target.value)}
      />
      <Input
        placeholder="Label"
        value={nameValue}
        onBlur={onBlur}
        onChange={(e) => handleNameChange(e.target.value)}
      />
    </div>
  );
};
